var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconBioface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#CEDCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#4974D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.667 49.3334V44.0001C38.667 42.5856 39.2289 41.229 40.2291 40.2288C41.2293 39.2287 42.5858 38.6667 44.0003 38.6667H49.3337M38.667 70.6667V76.0001C38.667 77.4146 39.2289 78.7711 40.2291 79.7713C41.2293 80.7715 42.5858 81.3334 44.0003 81.3334H49.3337M70.667 38.6667H76.0003C77.4148 38.6667 78.7714 39.2287 79.7716 40.2288C80.7718 41.229 81.3337 42.5856 81.3337 44.0001V49.3334M70.667 81.3334H76.0003C77.4148 81.3334 78.7714 80.7715 79.7716 79.7713C80.7718 78.7711 81.3337 77.4146 81.3337 76.0001V70.6667M52.0003 54.6667H52.027M68.0003 54.6667H68.027M53.3337 68.0001C54.2027 68.887 55.2399 69.5916 56.3847 70.0726C57.5294 70.5537 58.7586 70.8014 60.0003 70.8014C61.242 70.8014 62.4712 70.5537 63.616 70.0726C64.7607 69.5916 65.798 68.887 66.667 68.0001",
    stroke: "#F8F8F8",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconBioface);
export default __webpack_public_path__ + "static/media/img-icon-bioface.74cdcfe907a2eed51ab86346d21d4d61.svg";
export { ForwardRef as ReactComponent };